import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import SpecialtySubPicker from "./SpecialtySubPicker";
import { useLanguage } from "../../../../../../API/Context/LanguageContext";
import SpecialtiesService from "../../../../../../API/Services/SpecialtiesService";
import { VocabSkills } from "../../../../../../ConfigFiles/multilingual/VocabSkills";

interface SpecialtySubSectionProps {
  specialtyId: string | null;
  subspecialtyId: string | null;
  specialtiesMeta: Record<string, { name: string }>;
  subspecialtiesMeta: Record<string, { name: string }>;
  specService: SpecialtiesService;
  onSelectSpecialty: (spec: { id: string; name: string } | null, isClear?: boolean) => void;
  onSelectSubspecialty: (sub: { id: string; name: string } | null) => void;
}

export const SpecialtySubSection: React.FC<SpecialtySubSectionProps> = ({
  specialtyId,
  subspecialtyId,
  specialtiesMeta,
  subspecialtiesMeta,
  specService,
  onSelectSpecialty,
  onSelectSubspecialty,
}) => {
  const { t } = useLanguage();

  return (
    <Row className="g-3 mb-4">
      {/* SPECIALTY */}
      <Col md={6}>
        <Form.Label className="small fw-bold">{t(VocabSkills, "specialty")}</Form.Label>
        <SpecialtySubPicker
          placeholder={t(VocabSkills, "search_skill_placeholder")}
          searchFunction={(query: string, signal?: AbortSignal) => specService.searchSpecialties(query, signal)}
          selectedValue={specialtyId}
          selectedLabel={specialtyId ? specialtiesMeta?.[specialtyId]?.name : undefined}
          onSelect={onSelectSpecialty}
        />
      </Col>

      {/* SUBSPECIALTY */}
      <Col md={6}>
        <Form.Label className="small fw-bold">{t(VocabSkills, "subspecialty")}</Form.Label>
        <SpecialtySubPicker
          placeholder={t(VocabSkills, "search_skill_placeholder")}
          disabled={!specialtyId}
          searchFunction={(query: string, signal?: AbortSignal) =>
            specService.searchSubspecialties(query, specialtyId, signal)
          }
          selectedValue={subspecialtyId}
          selectedLabel={subspecialtyId ? subspecialtiesMeta?.[subspecialtyId]?.name : undefined}
          onSelect={onSelectSubspecialty}
        />
      </Col>
    </Row>
  );
};